import { type Perspectives, getPerspectivesFn } from "../common/openapi";

import type { UseFullQueryOptions } from "./react-query";

export const queryPerspectives = ((presentationOrViewUrn: string) => ({
	queryKey: ["perspectives", presentationOrViewUrn] as const,
	queryFn: () => getPerspectivesFn({ presentationOrViewUrn }),
})) satisfies (urn: string) => UseFullQueryOptions<Perspectives, Error>;
